import { memo, useCallback, useEffect, useState } from "react"
import { useDispatch } from 'react-redux'
import { callApiAction } from "../../store/actions/commonAction"
import { closeModal, openModal } from "../../store/actions/modalAction"
import { findNameByRole, findObjectKeyByValue, titleCase } from "../../utils/helper"
import { Box, CircularProgress, IconButton, Switch, Typography } from "@mui/material"
import { useMemo } from "react"
import { Delete, Download, Edit } from "@mui/icons-material"
import MessageDilog from "../../components/MessageDilog"
import { REGIONS_TYPE, USER_ROLES } from "../../utils/constants"
import { deleteDocumentsField, getDocumentsApi } from "../../apis/documents.api"
import KeyDocumentListUi from "./KeyDocumentListUi"
import KeyDocumentCreateController from "./KeyDocumentCreateController"
import { deleteKeyDocumentsField, getKeyDocumentByIdApi, getKeyDocumentsApi } from "../../apis/keydocument.api"
import fileDownload from "js-file-download"
import FileDownloadComponent from "../../components/FileDownloadComponent"

const ActionComponent = memo(({ params, setParams, deleteApi, modalKey }) => {
    const dispatch = useDispatch()

    const [loading, setLoading] = useState(false)

    // const onDownloadDocument = () =>{
    //         setLoading(true)
    //         dispatch(callApiAction(
    //             async () => await getKeyDocumentByIdApi({ id: params._id }),
    //             (response) => {
    //                 console.log("Response",response)
    //                 // FileDownloadComponent({src:response})
    //                 fileDownload(response, params.title + ".pdf")
    //                 setLoading(false)
    //             },
    //             (err) => {
    //                 console.log(err)
    //                 setLoading(false)
    //             },
    //             true
    //         ))
    // }

    const onDelete = () => {
        dispatch(openModal(<MessageDilog
            title="Alert!"
            message={"Are you sure to delete " + params.title + "?"}

            onSubmit={(e) => {
                e.preventDefault()
                setLoading(true)
                dispatch(callApiAction(
                    async () => await deleteApi({ id: params._id }),
                    (response) => {
                        setParams({})
                        setLoading(false)
                        dispatch(closeModal('delete'))
                    },
                    (err) => {
                        setLoading(false)
                    }
                ))
            }}

        />, "sm", false, "delete"))
    }

    if (loading) {
        return <CircularProgress />
    }
    return <Box sx={{ width: "100%", alignItems: "flex-start", display: "flex" }}>
        {/* <IconButton href={params.document_url} target="_blank" onClick={onDownloadDocument}>
            <Download color="primary" fontSize="inherit" />
        </IconButton> */}
        <IconButton size="inherit" onClick={onDelete}>
            <Delete color="error" fontSize="inherit" />
        </IconButton>

    </Box>
})



const KeyDocumentListController = () => {
    const dispatch = useDispatch()

    const title = "Key Documents "
    const modalKey = 'document'
    const fetchApi = getKeyDocumentsApi
    const deleteApi = deleteKeyDocumentsField


    const columns = useMemo(() => [

        { id: 1, fieldName: 'title', label: 'Document Name', align: "left", sort: true },
        {
            id: 4,
            fieldName: "document_url",
            label: "Document Download",
            align: "left",
            minWidth: "150px",
            renderValue: (params) => (
              <FileDownloadComponent
                src={params.document_url}
                downloadName={params.title + ".pdf"}
              />
            ),
          },
        {
            id: 5,
            fieldName: '',
            label: 'Action',

            align: "right",
            renderValue: (params, setParams) => <ActionComponent modalKey={modalKey} deleteApi={deleteApi} params={params} setParams={setParams} />
        },

    ], [dispatch]);


    const [filters, setFilters] = useState({
        pageNo: 1,
        pageSize: 10,
        search: '',
        searchable: ['title'],
        sort: 'title',
        sortDirection: 1

    })

    const [loading, setLoading] = useState(false)
    const [list, setList] = useState({})

    const fetchList = () => {
        setLoading(true)
        dispatch(callApiAction(
            async () => await fetchApi({ ...filters }),
            (response) => {
                setList(response)
                setLoading(false)
            },
            (err) => {
                setLoading(false)
            }
        ))
    }
    const onCreateBtnClick = () => {
        dispatch(openModal(<KeyDocumentCreateController callBack={async () => { fetchList() }} />, "sm", false, modalKey))
    }



    useEffect(() => {
        fetchList()
    }, [filters])



    return (
        <>
            <KeyDocumentListUi
                title={title}
                onCreateBtnClick={onCreateBtnClick}

                filters={filters}
                setFilters={setFilters}
                loading={loading}
                list={list}
                columns={columns}


            />

        </>
    )
}
export default KeyDocumentListController